import { createProvider } from '@nvision/services/data-provider';

import type { EquipmentTypeFilters } from '../../models';
import * as api from './api';
import { normalizeEquipmentTypeFilters, normalizeEquipmentTypes } from './normalize';

export const fetchEquipmentTypes = createProvider(
  (filters: Partial<EquipmentTypeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchEquipmentTypes(normalizeEquipmentTypeFilters(filters), { signal }),
).andThen((res) => normalizeEquipmentTypes(res));
